import React, { useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import {
  Elements,
  CardNumberElement,
  CardCvcElement,
  CardExpiryElement,
  useStripe,
  useElements,
} from "@stripe/react-stripe-js";
import { create_customer } from "../../redux/authslice";
import { useDispatch } from "react-redux";
import { IoMdArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";

const stripePromise = loadStripe(
  "pk_test_51LO3JEFAnyhBCihtrocid7zoD6qf2nYvQSrlGesCY7UYNwR2IHtcvzlw5gPlkjNcmai9L86oHsYHILi9UgX2PTvT00yvD2b6z5"
);

const CardForm = ({ setShow, setShowpay, setAutopay }) => {
  const dispatch = useDispatch();
  let navigate = useNavigate();

  const [formData, setFormData] = useState({
    name_on_card: "",
    token: "",
    line_1: "",
    postal_code: "",
    country: "",
  });

  const [errors, setErrors] = useState({});

  const stripe = useStripe();
  const elements = useElements();

  const updateValue = (fieldName, value) => {
    if (["card_number", "cvv", "postal_code"].includes(fieldName)) {
      value = value.replace(/\D/g, "");
    }
    setFormData({ ...formData, [fieldName]: value });
    setErrors({ ...errors, [fieldName]: "" });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors)?.length === 0) {
      if (!stripe || !elements) {
        console.error("Stripe or Elements not loaded");
        return;
      }

      const cardElement = elements.getElement(CardNumberElement);
      const cvcElement = elements.getElement(CardCvcElement);
      const expiryElement = elements.getElement(CardExpiryElement);

      if (!cardElement || !cvcElement || !expiryElement) {
        console.error("CardElement, CvcElement, or ExpiryElement not found");
        return;
      }

      try {
        const { token, error } = await stripe.createToken(cardElement);

        if (error) {
          console.error("Error creating Stripe token:", error);
          setErrors({ stripe: error.message });
        } else {

          dispatch(
            create_customer({
              formData: { ...formData, token: token.id },
              navigate,
              dispatch,
              setShow,
              setShowpay,
              setAutopay,
            })
          );
          setFormData({
            name_on_card: "",
            token: "",
            line_1: "",
            postal_code: "",
            country: "",
          });
          setShow(false);
          setErrors({});
          cardElement.clear();
          cvcElement.clear();
          expiryElement.clear();
        }
      } catch (error) {
        console.error("Error creating Stripe token:", error);
        setErrors({ stripe: error.message });
      }
    } else {
      setErrors(validationErrors);
    }
  };

  const validate = () => {
    let errors = {};

    if (!formData.postal_code) {
      errors.postal_code = "Required";
    } else if (!/^[a-zA-Z0-9]{5,10}$/.test(formData.postal_code)) {
      errors.postal_code =
        "Postal code must be alphanumeric and between 5 to 10 characters";
    }

    if (!formData.line_1) errors.line_1 = "Required";
    if (!formData.country) errors.country = "Required";
    if (!formData.name_on_card) errors.name_on_card = "Required";

    return errors;
  };

  return (
    <>
      <section className="login-page-new-card">
        <div className="container">
          {/* <button className="div-save-bt" onClick={() => navigate(-1)}>
            <IoMdArrowBack />
            &nbsp;Back
          </button> */}
          <div className="new-card-content">
            {/* <div className="new-card-header">
              <h5 className="new-card-title">
                Add New Card
                <button
                  type="button"
                  className="btn-close float-end"
                  aria-label="Close"
                />
              </h5>
            </div> */}
            <div className="new-card-body">
              <form onSubmit={handleSubmit}>
                <div className="new-card-input name">
                  <label htmlFor="cardName" className="form-label card-no">
                    Name on card
                  </label>
                  <input
                    type="text"
                    className={`form-control placeholder-size ${
                      errors.name_on_card ? "is-invalid" : ""
                    }`}
                    placeholder="Name on card"
                    name="name_on_card"
                    value={formData.name_on_card}
                    onChange={(e) =>
                      updateValue("name_on_card", e.target.value)
                    }
                    autoComplete="on"
                  />
                  {errors.name_on_card && (
                    <div className="invalid-feedback">
                      {errors.name_on_card}
                    </div>
                  )}
                </div>
                <div className="new-card-input">
                  <label htmlFor="cardNumber" className="form-label card-no">
                    Card number
                  </label>
                  <CardNumberElement
                    options={{ showIcon: true }}
                    className={`form-control placeholder-size`}
                    onChange={(e) =>
                      setErrors({
                        ...errors,
                        card_number: e.error ? e.error.message : null,
                      })
                    }
                  />
                  {errors.card_number && (
                    <div className="invalid-feedback">{errors.card_number}</div>
                  )}
                </div>
                <div className="row mb-2">
                  <div className="col-md-6 mb-2">
                    <label htmlFor="cvv" className="form-label card-no">
                      CVC
                    </label>
                    <CardCvcElement
                      className={`form-control placeholder-size `}
                      onChange={(e) =>
                        setErrors({
                          ...errors,
                          cvv: e.error ? e.error.message : null,
                        })
                      }
                    />
                    {errors.cvv && (
                      <div className="invalid-feedback">{errors.cvv}</div>
                    )}
                  </div>
                  <div className="col-md-6 mb-2">
                    <label htmlFor="expiryDate" className="form-label card-no">
                      Expire date
                    </label>
                    <CardExpiryElement
                      className={`form-control placeholder-size `}
                      onChange={(e) =>
                        setErrors({
                          ...errors,
                          expire_date: e.error ? e.error.message : null,
                        })
                      }
                    />
                    {errors.expire_date && (
                      <div className="invalid-feedback">
                        {errors.expire_date}
                      </div>
                    )}
                  </div>
                  <div className="col-md-6 mb-2">
                    <label htmlFor="line1" className="form-label card-no">
                      Address line 1
                    </label>
                    <input
                      type="text"
                      className={`form-control placeholder-size ${
                        errors.line_1 ? "is-invalid" : ""
                      }`}
                      placeholder="Address line 1"
                      name="line_1"
                      value={formData.line_1}
                      onChange={(e) => updateValue("line_1", e.target.value)}
                    />
                    {errors.line_1 && (
                      <div className="invalid-feedback">{errors.line_1}</div>
                    )}
                  </div>
                  <div className="col-md-6 mb-2">
                    <label htmlFor="postalCode" className="form-label card-no">
                      Postal code
                    </label>
                    <input
                      type="text"
                      className={`form-control placeholder-size ${
                        errors.postal_code ? "is-invalid" : ""
                      }`}
                      placeholder="Postal code"
                      name="postal_code"
                      value={formData.postal_code}
                      onChange={(e) =>
                        updateValue("postal_code", e.target.value)
                      }
                    />
                    {errors.postal_code && (
                      <div className="invalid-feedback">
                        {errors.postal_code}
                      </div>
                    )}
                  </div>
                  <div className="col-md-6 mb-2">
                    <label htmlFor="country" className="form-label card-no">
                      Country
                    </label>
                    <input
                      type="text"
                      className={`form-control placeholder-size ${
                        errors.country ? "is-invalid" : ""
                      }`}
                      placeholder="Country"
                      name="country"
                      value={formData.country}
                      onChange={(e) => updateValue("country", e.target.value)}
                    />
                    {errors.country && (
                      <div className="invalid-feedback">{errors.country}</div>
                    )}
                  </div>
                </div>
                <div className="d-flex justify-content-end">
                  <button type="submit" className="btn submit-btn ">
                    Add card
                  </button>
                  {/* <button type="button" className="btn cancel-btn">
                    Cancel
                  </button> */}
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

const Card = ({ setShow, setShowpay, setAutopay }) => (
  <Elements stripe={stripePromise}>
    <CardForm
      setShow={setShow}
      setShowpay={setShowpay}
      setAutopay={setAutopay}
    />
  </Elements>
);

export default Card;
